import frontImg from "@/assets/bodymap/front.png";
import backImg from "@/assets/bodymap/back.png";

// Read-only office view of the injury body chart captured by the worker.
// Renders the same front/back figures with numbered pins, no interaction.

const VIEWS = [["front", "Front", frontImg], ["back", "Back", backImg]];

function parsePins(value) {
  if (Array.isArray(value)) return value;
  if (typeof value === "string" && value.trim()) {
    try { const p = JSON.parse(value); return Array.isArray(p) ? p : []; } catch { return []; }
  }
  return [];
}

export function BodyMapView({ value, testid = "bodymap-view" }) {
  const pins = parsePins(value);
  if (!pins.length) return null;

  return (
    <div className="flex gap-4" data-testid={testid}>
      {VIEWS.map(([v, label, img]) => {
        const vp = pins.map((p, i) => ({ ...p, i })).filter((p) => p.view === v);
        return (
          <div key={v} className="w-28 sm:w-32" data-testid={`${testid}-${v}`}>
            <div className="text-[10px] text-slate-400 text-center mb-1 uppercase tracking-wide">{label}</div>
            <div className="relative rounded-lg bg-slate-50 border border-slate-200 overflow-hidden" style={{ aspectRatio: "848 / 1264" }}>
              <img src={img} alt={`${label} body view`} draggable={false} className="w-full h-full object-contain select-none p-1" />
              {vp.map((p) => (
                <span
                  key={p.i}
                  data-testid={`${testid}-pin-${p.i}`}
                  className="absolute -translate-x-1/2 -translate-y-1/2 h-5 w-5 rounded-full bg-red-500 border-2 border-white text-white text-[9px] font-bold flex items-center justify-center shadow"
                  style={{ left: `${p.x}%`, top: `${p.y}%` }}
                >
                  {p.i + 1}
                </span>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
